/** Canonical site URL — set REACT_APP_SITE_URL at build time for production. */
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL ?? 'https://www.zoellner-lorenz.de'
).replace(/\/$/, '');

export const SITE_NAME = 'Zöllner Lorenz';

export const DEFAULT_SEO = {
  title: 'Familienrecht & Mediation in München | Zöllner Lorenz',
  description:
    'Familienrecht, Mediation und Cooperative Praxis in München – bei Trennung, Scheidung, Unterhalt und Vermögensfragen. Lösungsorientiert und mit Weitsicht.',
  ogImage: `${SITE_URL}/images/og.jpg`,
} as const;

export const ORG = {
  legalName: 'Zöllner Lorenz Partnerschaft von Rechtsanwälten mbB',
  streetAddress: 'Maximiliansplatz 12a',
  postalCode: '80333',
  addressLocality: 'München',
  addressCountry: 'DE',
  telephone: '+49-89-24889752',
  email: 'info@zoellner-lorenz.de',
  logoUrl: `${SITE_URL}/images/logo-zl-dark.svg`,
} as const;
